import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunkWithLoggingAndRetry } from '../../../store/middleware/thunk_helper';
import {
  getCMRRevenueCycleServices as getCMRRevenueCycleServicesService,
  updateCMRRevenueCycleService as updateCMRRevenueCycleServiceService,
} from '../../../services/cmrRevenueCycleService';
import { FAILED, PENDING, REQUESTING, SUCCESS } from '../../../actions/statusTypes';

const _getCMRRevenueCycleServices = createAsyncThunkWithLoggingAndRetry(
  'cmrRevenueCycle/getServices',
  ({ employerId }) => {
    return getCMRRevenueCycleServicesService(employerId);
  }
);

const _updateCMRRevenueCycleService = createAsyncThunkWithLoggingAndRetry(
  'cmrRevenueCycle/updateService',
  ({ employerId, serviceId, updates }) => {
    return updateCMRRevenueCycleServiceService(employerId, serviceId, updates);
  }
);

export const getCMRRevenueCycleServices = ({ employerId }) => {
  return (dispatch, getState) => {
    const state = getState().screens.cmrRevenueCycle;
    if (state.servicesStatus === REQUESTING) {
      return Promise.resolve(null);
    }

    return dispatch(_getCMRRevenueCycleServices({ employerId }));
  };
};

export const updateCMRRevenueCycleService = (params) => {
  return async (dispatch) => {
    const result = await dispatch(_updateCMRRevenueCycleService(params));

    if (_updateCMRRevenueCycleService.fulfilled.match(result)) {
      await dispatch(getCMRRevenueCycleServices({ employerId: params.employerId }));
    }

    return result;
  };
};

const INITIAL_STATE = {
  employerId: null,
  servicesStatus: PENDING,
  servicesError: null,
  servicesData: [],
  servicesActiveRequestId: null,
  updateServiceStatus: PENDING,
  updateServiceError: null,
};

const cmrRevenueCycleSlice = createSlice({
  name: 'cmrRevenueCycle',
  initialState: INITIAL_STATE,
  reducers: {
    resetCMRRevenueCycleStatus: (state) => {
      state.updateServiceStatus = PENDING;
      state.updateServiceError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(_getCMRRevenueCycleServices.pending, (state, action) => {
        state.employerId = action.meta.arg.employerId;
        state.servicesStatus = REQUESTING;
        state.servicesError = null;
        state.servicesActiveRequestId = action.meta.requestId;
      })
      .addCase(_getCMRRevenueCycleServices.fulfilled, (state, action) => {
        if (state.servicesActiveRequestId !== action.meta.requestId) return;

        state.servicesStatus = SUCCESS;
        state.servicesData = action.payload || [];
        state.servicesError = null;
        state.servicesActiveRequestId = null;
      })
      .addCase(_getCMRRevenueCycleServices.rejected, (state, action) => {
        if (state.servicesActiveRequestId !== action.meta.requestId) return;

        state.servicesStatus = FAILED;
        state.servicesError = action.payload;
        state.servicesActiveRequestId = null;
      })
      .addCase(_updateCMRRevenueCycleService.pending, (state) => {
        state.updateServiceStatus = REQUESTING;
        state.updateServiceError = null;
      })
      .addCase(_updateCMRRevenueCycleService.fulfilled, (state) => {
        state.updateServiceStatus = SUCCESS;
      })
      .addCase(_updateCMRRevenueCycleService.rejected, (state, action) => {
        state.updateServiceStatus = FAILED;
        state.updateServiceError = action.payload;
      });
  },
});

export const { resetCMRRevenueCycleStatus } = cmrRevenueCycleSlice.actions;
export default cmrRevenueCycleSlice.reducer;
